import { Chip } from "@mui/material";
import { useAuth } from "../auth/context";

const TestEnvironmentChip = ({ sx }) => {
  const { user } = useAuth();

  // isTestAccount comes from api (@recetario.com.ar doctor accounts — assistants have none).
  if (!user?.isTestAccount) return null;

  return (
    <Chip
      label="Ambiente de pruebas"
      size="small"
      sx={{
        borderRadius: "8px",
        fontWeight: 500,
        fontSize: 13,
        width: "fit-content",
        color: "#92400E",
        backgroundColor: "#FFF3E0",
        border: "1px solid #C2680A",
        ...sx,
      }}
    />
  );
};

export default TestEnvironmentChip;
